import React, { useEffect } from 'react';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Link, useParams } from 'react-router';

import { Header } from './project.page';
import { Character } from '../../app/entities/character';
import { CharacterInfoTab } from '../../features/character/components/character-info-tab';
import { uiStore } from '../../core/stores/ui-store';

import styles from './project-character.route.module.scss';
export const ProjectCharacterRoute = () => {
  const { characterId } = useParams() as { characterId: string };

  const character = Character.getOne(characterId)!;

  useEffect(() => {
    uiStore.currentLocation = 'project.characters';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Characters
          </Link>
          <ChevronRightIcon />
          {character.name}
        </div>
      </Header>

      <div className={styles['container']}>
        <CharacterInfoTab characterId={characterId} />
      </div>
    </>
  );
};
